import styled from '@emotion/styled';

const Add = styled('div')({
  cursor: 'pointer',
  position: 'relative',
});

export default Add;
